/**
 * Entry modal javascript actions
 */
export default function entryActions() {
    autoOpenRexamsModal();

    /**
     * Auto-open re-exam modal when user click 'print re-exam' from the Admin back-end.
     */
    function autoOpenRexamsModal() {
        const $formEntrySection = $( '.o__ime-form-entry' );
        const reexamModalValue = $formEntrySection.attr( 'data-open-reexam-modal' );

        if ( !reexamModalValue ) {
            return;
        }

        const reexamModalElement = $( `.open-modal-${reexamModalValue}` );

        if ( reexamModalElement.length > 0 ) {
            reexamModalElement.click();
        }
    }
}